import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import './PaymentSuccess.scss'

const PaymentSuccess = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <div class="payment-success-container">
            <div class="success-card fadeInDown">

                <div class="card-title">
                    <i class="fas fa-check" style={{ maxHeight: "3.75rem" }} />
                    <p>{t('payment.success.info')}</p>

                    <button>
                        <Link class="log-in fadeInDown" to="/community/1">{t('payment.success.cta')}</Link>
                    </button>
                </div>

            </div>
        </div >
    )
}



export default PaymentSuccess